import { FuelSkeleton } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { MAP_HEIGHT } from 'constants/styled.contants';
import React from 'react';

const SkeletonMap: React.FC = () => (
  <FuelFlex testId="map-skeleton">
    <FuelSkeleton size="custom" shape="square" width="100%" height={`${MAP_HEIGHT}px`} />
  </FuelFlex>
);
export default SkeletonMap;
